export const transitionPages = {
  initial: { opacity: 0, x: "-80px" },
  exit: {
    opacity: 0,
    x: "-80px",
    transition: {
      duration: 0.3,
    },
  },
  animate: { opacity: 1, x: 0 },
  transition: {
    type: "spring",
    stiffness: 50,
  },
};
